import React, { useEffect, useState } from 'react'
import { postVerSuministrosDespachadosPaqueteNoventaYCuatroQxFarmacia, postVerSuministrosDespachosQxFarmacia } from '../../../services/FarmaciaRuta'
import Loading from '../../Loading'
import TablaVerSuministrosDespachosQxFarmacia from './TablaVerSuministrosDespachosQxFarmacia'
import config from "../../../config";

const ModalVerSuministrosDespachosQxFarmacia = ({setmodalOnVersuministros,item}) => {
  const usuarioInfo = JSON.parse(localStorage.getItem('usuarioInfo'));
    const [datasSuministros,setdatasSuministros]=useState([])
    const [loading,setloading]=useState(false)
    const handleCancelarClick=()=>{
        setmodalOnVersuministros(false)
    }
    useEffect(()=>{
      //console.log(item,'item')
      setloading(false)
      const verSuministros={
        ProCirCod: item.ProCirCod,
        PaqCod: item.PaqCod,
        ProEmpCod:usuarioInfo.Empresa,
        ProMCDpto:usuarioInfo.Sede,
        MPCedu: item.MPCedu
      }

      //clinica cartagena
      // const paqueteGenericoCodigo = '39'
            

      //produccion pruebas 
      // const paqueteGenericoCodigo = '94'

      //clinica estancia
      // const paqueteGenericoCodigo = 'GER'

      //variable de entorno
      const paqueteGenericoCodigo = config.PAQUETE_GENERICO_ID

      console.log(verSuministros,'ver antes')
      // if(parseInt(item.PaqCod) === parseInt(paqueteGenericoCodigo)){
        if(item.PaqCod.trim() === paqueteGenericoCodigo.trim()){
        console.log('entro')
        postVerSuministrosDespachadosPaqueteNoventaYCuatroQxFarmacia(verSuministros).then((res)=>{
          console.log(res.data, 'paquete 94')
          setloading(true)
          setdatasSuministros(res.data)
        })
      }else{
        console.log('no entro')
        postVerSuministrosDespachosQxFarmacia(verSuministros).then((res)=>{
          
          setloading(true)
          if(res.data.contratoPortafolio){
            setdatasSuministros(res.data.contratoPortafolio)
          }else{
            setdatasSuministros(res.data.contratoSinPortafolio)
          }
          console.log(res.data,'data suministrosss hola')
          //let data= Object.values(res.data)
          
          
        })
      }
     
    },[])
  return (
    <div
    className="z-40 fixed top-0 left-0 w-full h-full outline-none overflow-x-hidden overflow-y-auto bg-[#f4f6fa]"
    id="exampleModalScrollable"
    tabIndex="-1"
    aria-labelledby="exampleModalScrollableLabel"
    aria-hidden="true"
  >
    <div className="sm:h-[calc(100%)]  mx-auto relative w-auto pointer-events-none ">
      <div className="max-h-full overflow-hidden border-none shadow-lg relative flex flex-col w-full pointer-events-auto bg-white bg-clip-padding rounded-md outline-none text-current">
        <div className="flex flex-shrink-0 items-center justify-between p-2 border-b border-gray-200 rounded-t-md bg-[#9e56fe]">
          <h5
            className="text-xl font-medium leading-normal text-white"
            id="exampleModalScrollableLabel"
          >
            Despachos de Cirugía
          </h5>
          <button
            type="button"
            onClick={handleCancelarClick}
            className="btn-close box-content w-4 h-4 p-1 text-black border-none rounded-none opacity-50 focus:shadow-none focus:outline-none focus:opacity-100 hover:text-black hover:opacity-75 hover:no-underline"
            data-bs-dismiss="modal"
            aria-label="Close"
          >
            X
          </button>
        </div>
        <div className="flex-auto overflow-y-auto relative p-2">            
            <div className="flex py-2 text-left">
              <div className="w-1/6  px-1">
                <label className="form-label inline-block mb-2 text-gray-900 font-medium">
                  Cirugía
                </label>
                <div className="flex">
                  <input
                    //   onChange={searchUserId}
                    //defaultValue={props.userDate[0].ProEmpCod}
                    defaultValue={item.ProCirCod}
                    disabled={true}
                    type="number"
                    name="cedula"
                    autoComplete="off"
                    className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                    id="exampleFormControlInput1"
                    placeholder=""
                  />
                </div>
              </div>
              <div className="w-1/6  px-1">
                <label className="form-label inline-block mb-2 text-gray-900 font-medium">
                  Paquete
                </label>
                <div className="flex">
                  <input
                    //   onChange={searchUserId}
                    //defaultValue={props.userDate[0].ProEmpCod}
                    //defaultValue={props.userDate.ProEmpCod}
                    defaultValue={item.PaqCod}
                    disabled={true}
                    name="codigoMedico"
                    type="text"
                    autoComplete="off"
                    className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                    id="exampleFormControlInput1"
                    placeholder=""
                  />
                  
                </div>
              </div>
              <div className="w-1/6  px-1">
                <label className="form-label inline-block mb-2 text-gray-900 font-medium">
                  Cantidad
                </label>
                <div className="flex">
                  <input
                    //   onChange={searchUserId}
                    //defaultValue={props.userDate[0].ProEmpCod}
                    //defaultValue={props.userDate.ProEmpCod}
                    defaultValue={item.PQCantPaq}
                    disabled={true}
                    name="codigoMedico"
                    type="text"
                    autoComplete="off"
                    className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                    id="exampleFormControlInput1"
                    placeholder=""
                  />
                  
                </div>
              </div>
              <div className="w-3/6  px-1">
                <label className="form-label inline-block mb-2 text-gray-900 font-medium">
                  Nombre Paquete
                </label>
                <div className="flex">
                  <input
                    //   onChange={searchUserId}
                    //defaultValue={props.userDate[0].ProEmpCod}
                    //defaultValue={props.userDate.ProEmpCod}
                    defaultValue={item.PaqDes}
                    disabled={true}
                    name="codigoMedico"
                    type="text"
                    autoComplete="off"
                    className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                    id="exampleFormControlInput1"
                    placeholder=""
                  />
                  
                </div>
              </div>
            </div>
            <div className="flex py-2 text-left">
              <div className="w-1/3  px-1">
                <label className="form-label inline-block mb-2 text-gray-900 font-medium">
                  Tipo de Documento 
                </label>
                <div className="flex">
                  <input
                    //   onChange={searchUserId}
                    //defaultValue={props.userDate[0].ProEmpCod}
                    defaultValue={item.MPTDoc}
                    //name="especialidadMedico"
                    disabled={true}
                    type="text"
                    autoComplete="off"
                    className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                    id="exampleFormControlInput1"
                    placeholder=""
                  />
                  
                </div>
              </div>
              <div className="w-1/3  px-1">
                <label className="form-label inline-block mb-2 text-gray-900 font-medium">
                  Número Documento 
                </label>
                <div className="flex">
                  <input
                    //   onChange={searchUserId}
                    //defaultValue={props.userDate[0].ProEmpCod}
                    defaultValue={item.MPCedu}
                    //name="especialidadMedico"
                    disabled={true}
                    type="text"
                    autoComplete="off"
                    className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                    id="exampleFormControlInput1"
                    placeholder=""
                  />
                  
                </div>
              </div>
              <div className="w-1/3  px-1">
                <label className="form-label inline-block mb-2 text-gray-900 font-medium">
                  Nombre
                </label>
                <div className="flex">
                  <input
                    //   onChange={searchUserId}
                    //defaultValue={props.userDate[0].ProEmpCod}
                    defaultValue={item.MPNOMC}
                    //name="especialidadMedico"
                    disabled={true}
                    type="text"
                    autoComplete="off"
                    className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                    id="exampleFormControlInput1"
                    placeholder=""
                  />
                  {/* <button
                    type="submit"
                    className="inline-block px-6 py-2.5 bg-blue-600 text-white font-medium text-xs leading-tight uppercase rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out ml-1"
                  >
                    Buscar
                  </button> */}
                </div>
              </div>
            </div>
            
          
          <div className="flex flex-col rounded-none">
            <div className="overflow-x-auto ">
              <div className="py-2 inline-block min-w-full ">
                <div className="overflow-hidden">
                  <table className="min-w-full text-center bg-gray-200 ">
                    <thead className="">
                      <tr>
                      <th
                          scope="col"
                          
                        >
                          
                        </th>
                      <th
                          scope="col"
                          className="text-sm font-medium text-gray-900 px-6 py-4"
                        >
                          Suministro
                        </th>
                        <th
                          scope="col"
                          className="text-sm font-medium text-gray-900 px-6 py-4"
                        >
                          Descripción
                        </th>
                        
                        <th
                          scope="col"
                          className="text-sm font-medium text-gray-900 px-6 py-4"
                        >
                          Solicitado
                        </th>
                        <th
                          scope="col"
                          className="text-sm font-medium text-gray-900 px-6 py-4"
                        >
                          Despachado
                        </th>
                        
                        
                        
                      </tr>
                    </thead>
                    {loading?
                      datasSuministros.map((item,index)=>(
                        <TablaVerSuministrosDespachosQxFarmacia key={index} item={item} />
                      ))
                      :
                      <tbody className="">
                          <tr>
                            <td></td>
                            <td></td>
                            
                            
                            <td><Loading/></td>
                          </tr>
                      </tbody>
                    }
                    
                     
                    
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="flex flex-shrink-0 flex-wrap items-center justify-end p-2 border-t border-gray-200 rounded-b-md">
          <button
            type="button"
            onClick={handleCancelarClick}
            className="inline-block px-4 py-1.5 bg-purple-600 text-white font-medium text-xs leading-tight  rounded shadow-md hover:bg-purple-700 hover:shadow-lg focus:bg-purple-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-purple-800 active:shadow-lg transition duration-150 ease-in-out"
            data-bs-dismiss="modal"
          >
            Cancelar
          </button>
        </div>
      </div>
    </div>
  </div>
  )
}

export default ModalVerSuministrosDespachosQxFarmacia